export default "__VITE_ASSET__Can7rrjr__"